
































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import _ from "lodash";

import Setting from "./setting.vue";
import Detail from "./detail.vue";

@Component({
  components: {
    Setting,
    Detail
  }
})
export default class extends Mixins(MyList) {
  @Prop() msgCategoryId!: number;

  dispatchType: string = "notification/list";

  isRead: string[] = ["m3"];
  categoryId: string[] = ["t0"];

  categories: string[] = [];

  settingModalVisible: boolean = false;
  detailModalVisible: boolean = false;

  columns: any[] = [
    { title: "标题", scopedSlots: { customRender: "title" } },
    { title: "类型", dataIndex: "category_name" },
    { title: "时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "is_read" } }
  ];

  showSettingModal() {
    this.settingModalVisible = true;
  }

  hideSettingModal() {
    this.settingModalVisible = false;
  }

  showDetailModal(id: number) {
    this.editId = id;
    this.detailModalVisible = true;
  }

  hideDetailModal() {
    this.detailModalVisible = false;
    this.loadData2();
  }

  leftMenu(params: any) {
    // console.log(params);
    this.isRead = [params.key];
    this.loadData2();
  }

  topMenu(params: any) {
    console.log(params);
    this.categoryId = [params.key];
    if (_.indexOf(this.isRead, "m4") !== -1) {
      this.isRead = ["m3"];
    }
    this.loadData2();
  }

  linkTo(id: number, uri: string) {
    this.$router.push(uri);
    this.$store.dispatch("notification/detail", {
      id
    });
    this.handleCancel();
  }

  async loadData2() {
    const params: any = {};

    if (_.indexOf(this.isRead, "m1") !== -1) {
      // 全部
      params.is_read = "";
    } else if (_.indexOf(this.isRead, "m2") !== -1) {
      // 已读
      params.is_read = 1;
    } else if (_.indexOf(this.isRead, "m3") !== -1) {
      // 未读
      params.is_read = 0;
    } else if (_.indexOf(this.isRead, "m4") !== -1) {
      // 弹出配置
      this.showSettingModal();
    }

    if (_.indexOf(this.categoryId, "t0") !== -1) {
      // 全部类型
      params.category_id = "";
    } else {
      params.category_id = this.categoryId[0].replace("t", "");
    }

    this.loadData({ ...params });
  }

  async loadCategories() {
    const res = await this.$store.dispatch("notification/categories", {});
    if (res && res.Data) {
      this.categories = res.Data;
    }
  }

  mounted() {
    this.loading = true;

    this.loadCategories();
    this.categoryId = [`t${this.msgCategoryId}`];
    this.loadData2();
    this.loading = false;
  }
}
